import { useEffect, useState } from "react";
import { PageKonten30Stok } from "./Page30_stok";
import { Page23EventCabang } from "./Page23_EventCabang";
const DASHBOARD_NAV_INTENT_KEY = "__dashboard_nav_intent";

const INVENTORY_TABS = [
  {
    id: "tab2",
    label: "Mutasi Stok",
    subtitle: "Perpindahan stok ban antar lokasi inventori",
    accent: "MTS",
  },
  {
    id: "tab3",
    label: "Ubah Status Ban",
    subtitle: "Penyesuaian status ban dengan kondisi faktual.",
    accent: "STATUS",
  },
  {
    id: "tab4",
    label: "Event Lain",
    subtitle: "Aktivitas event inventori lainnya",
    accent: "EVL",
  },
];

export function PageKonten23({ globalOpsi, authIdentity = {}, token, setPage, resendToken = 0 }) {
  const [activeTab, setActiveTab] = useState("tab2");
  const [forcedActionTab2, setForcedActionTab2] = useState("");
  const [forcedActionTab3, setForcedActionTab3] = useState("");
  const [forcedActionKeyTab2, setForcedActionKeyTab2] = useState("");
  const activeTabMeta = INVENTORY_TABS.find((tab) => tab.id === activeTab) || INVENTORY_TABS[0];
  const kodeCabangUser = String(authIdentity?.kode_cabang || "").trim();
  const namaCabangUser = (
    kodeCabangUser === "C-1"
      ? "Pusat"
      : (
        (Array.isArray(globalOpsi?.opsiCabang) ? globalOpsi.opsiCabang : []).find(
          (x) => String(x?.kode_cabang || "").trim() === kodeCabangUser
        )?.nama_cabang || kodeCabangUser || "-"
      )
  );
  const namaUserAktif = String(authIdentity?.nama || "").trim();
  const sharedAuthProps = { authIdentity };
  useEffect(() => {
    if (typeof window === "undefined") return;
    const intent = window[DASHBOARD_NAV_INTENT_KEY];
    if (!intent || typeof intent !== "object") return;
    if (String(intent?.page || "").trim() !== "Page23") return;
    const tab = String(intent?.tab || "").trim();
    const action = String(intent?.action || "").trim();
    const key = String(intent?.key || "").trim();
    if (tab === "tab2" || tab === "tab3" || tab === "tab4") setActiveTab(tab);
    if (tab === "tab2") {
      setForcedActionTab2(action);
      setForcedActionKeyTab2(key);
    }
    if (tab === "tab3") setForcedActionTab3(action);
    delete window[DASHBOARD_NAV_INTENT_KEY];
  }, []);

  return (
    <div className="page-con-tabh otf-page">
      <div className="otf-header">
        <div className="otf-header-main">
          <h2 className="otf-title">Aktivitas Inventory</h2>
        </div>
        <div className="otf-header-meta">
          <div className="otf-meta-item">
            <small>Cabang</small>
            <strong>{String(namaCabangUser || "-")}</strong>
          </div>
          <div className="otf-meta-item">
            <small>User</small>
            <strong>{String(namaUserAktif || "-")}</strong>
          </div>
        </div>
      </div>

      <div className="container-con-tabh otf-shell">
        <div className="tabNav-con-tabh otf-tabs">
          {INVENTORY_TABS.map((tab) => (
            <button
              type="button"
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`otf-tab-btn ${activeTab === tab.id ? "is-active" : ""}`}
            >
              <span className="otf-tab-accent">{tab.accent}</span>
              <span className="otf-tab-copy">
                <strong>{tab.label}</strong>
                <small>{tab.subtitle}</small>
              </span>
            </button>
          ))}
        </div>

        <div className="content-con-tabh otf-content">
          <div className="otf-content-head">
            <div>
              <p className="otf-content-kicker mb-1">Menu Aktif</p>
              <h4 className="otf-content-title mb-1">{activeTabMeta.label}</h4>
              <p className="otf-content-subtitle mb-0">{activeTabMeta.subtitle}</p>
            </div>
          </div>
          {activeTab === "tab2" && (
            <div className="otf-tab-panel">
              <PageKonten30Stok
                globalOpsi={globalOpsi}
                {...sharedAuthProps}
                resendToken={resendToken}
                actionScope="mutasi_stok"
                forcedAction={forcedActionTab2}
                forcedActionKey={forcedActionKeyTab2}
              />
            </div>
          )}
          {activeTab === "tab3" && (
            <div className="otf-tab-panel">
              <PageKonten30Stok
                globalOpsi={globalOpsi}
                {...sharedAuthProps}
                resendToken={resendToken}
                actionScope="update_data_ban"
                forcedAction={forcedActionTab3}
              />
            </div>
          )}
          {activeTab === "tab4" && (
            <div className="otf-tab-panel">
              <Page23EventCabang
                globalOpsi={globalOpsi}
                {...sharedAuthProps}
                token={token}
                setPage={setPage}
                resendToken={resendToken}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
